import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { apolloClient } from "../../constants/apolloClient";
import { FeatureFlagQueryDocument } from "./graphql/FeatureFlagQuery.v2.generated";
function fetchV2FeatureFlag(_x) {
  return _fetchV2FeatureFlag.apply(this, arguments);
}
function _fetchV2FeatureFlag() {
  _fetchV2FeatureFlag = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var _data$featureFlag;
    var flagKey, _yield$apolloClient$q, data, error;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          flagKey = _ref.flagKey;
          _context.next = 3;
          return apolloClient.query({
            query: FeatureFlagQueryDocument,
            variables: {
              flagKey: flagKey
            }
          });
        case 3:
          _yield$apolloClient$q = _context.sent;
          data = _yield$apolloClient$q.data;
          error = _yield$apolloClient$q.error;
          return _context.abrupt("return", {
            error: error,
            flagKey: flagKey,
            apiVersion: 'V2',
            flagValue: !!(data !== null && data !== void 0 && (_data$featureFlag = data.featureFlag) !== null && _data$featureFlag !== void 0 && _data$featureFlag.isActive)
          });
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchV2FeatureFlag.apply(this, arguments);
}
export default fetchV2FeatureFlag;